import React from 'react'
import { Field } from 'redux-form'
import { InputError, Button } from '@foodsby/nutrient'
import Input from '../common/reduxForms/Input'
import { required, email, confirmation } from 'redux-form-validators/lib'
import { noSpacesAllowed } from '../../util/validators'
import { loginRoute } from '../../routes/routes'
import Submitting from '../common/Submitting'
import { Link } from 'react-router-dom'

const ForgotPasswordForm = ({
  error,
  handleSubmit,
  showSuccess,
  showFailure,
  submitting,
}) => (
  <div className="col-xs-12">
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12 center-xs">
          <h1 className="title">Reset Password</h1>
          {!showSuccess && (
            <p>
              Please enter your email address to receive instructions to reset
              your password.
            </p>
          )}
          <InputError>{error}</InputError>
        </div>
      </div>
      <div className="row center-xs">
        <div className="col-xs-12">
          {showSuccess ? (
            <div>
              <div className="success">
                An email has been sent. Please check your email and follow the
                link provided there.
              </div>
            </div>
          ) : (
            <div className="password-reset-wrapper">
              <Field
                component={Input}
                label="Email *"
                name="email"
                type="email"
                validate={[
                  noSpacesAllowed,
                  required({ msg: `Email is required` }),
                  email(),
                ]}
              />
              <Field
                component={Input}
                label="Confirm Email *"
                name="confirmEmail"
                type="email"
                validate={[noSpacesAllowed, confirmation({ field: 'email' })]}
              />
            </div>
          )}
        </div>
        {!showSuccess && (
          <div className="col-xs-12 center-xs">
            {submitting ? (
              <Submitting />
            ) : (
              <Button disabled={showSuccess} type="submit">
                Reset Password
              </Button>
            )}
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-xs-12 center-xs pt-1">
          <Link to={loginRoute.path}>
            <span className="icon-user" /> Log In
          </Link>
        </div>
      </div>
    </form>
  </div>
)
export default ForgotPasswordForm
